import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        thumbnailImageItem: {
            borderRadius: 'large',
            overflow: 'hidden',
            display: 'flex',
            width: remCalc(64),
            maxWidth: remCalc(64),
            height: remCalc(64),
            padding: 0,
            alignItems: 'center',
            gap: 0,
            aspectRatio: '1 / 1',
        },
        thumbnailImageItemActive: {
            boxShadow:
                '0 1px 2px 0 var(--neutral-sm, rgba(19, 24, 58, 0.12)), 0 0 0 2px var(--background-base-default, #EFEDEA), 0 0 0 4px var(--border-neutral-focus, #6C7BA8)',
        },
    },
    variants: {
        colorThumbnail: {
            thumbnailImageItem: {
                boxSizing: 'content-box',
                height: remCalc(80),
                width: remCalc(80),
                _hover: {
                    borderWidth: remCalc(2),
                    borderColor: 'border.dark',
                },
            },
        },
    },
}
